:root {
  --text: #17211b;
  --muted: #617067;
  --background: #fbfcfa;
  --surface: #fff;
  --surface-muted: #f0f5f1;
  --border: #d8e0da;
  --accent: #EC002F;
  --success: #2f7d4b;
  font-family:
    Inter,
    ui-sans-serif,
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;
  color: var(--text);
  background: var(--background);
  font-synthesis: none;
  text-rendering: optimizeLegibility;
}
* {
  box-sizing: border-box;
}
body {
  min-width: 320px;
  min-height: 100vh;
  margin: 0;
}
button,
progress {
  font: inherit;
}
